// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1jvLs","icon":"SortAdornment_icon__N8wmn","up":"SortAdornment_up__3l7tX","down":"SortAdornment_down__2RmDL","active":"SortAdornment_active__18xsD"};